<script setup>

</script>

<template>
    <div class="shadow-2xl rounded-lg mx-auto bg-white p-10 mt-5 w-full md:p-15 md:mt-10 md:min-w-192 md:w-1/3">
        <div class="flex flex-col items-center gap-5 mb-5">
            <div class="flex gap-5 md:flex-col">
                <img class="h-8 md:h-14" src="/storage/images/icon-dobyto.svg" alt="">
                <img class="h-8 md:h-14" src="/storage/images/logo-dobyto.svg" alt="Добыто.">
            </div>
            <p class="text-dark-light text-xs md:text-sm">Электронный документооборот</p>
        </div>
        <h1 class="font-semibold text-center mb-5 text-xl md:text-3xl"><slot name="title"/></h1>
        <div class="flex gap-5 flex-col items-center text-dark-2 text-center">
            <slot name="content"/>
        </div>
    </div>
</template>
